import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

type BrandHeartIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const BrandHeartIcon: React.FC<BrandHeartIconProps> = ({
  title = 'BrandHeart',
  viewBox = '0 0 61 48',
  ...props
}) => (
  <CreateIconComponent viewBox={viewBox} title={title} {...props}>
    {/* prettier-ignore */}
    <path d="M59.921 12.185c-1.672-4.635-5.063-8.343-9.548-10.44-6.157-2.88-13.308-2.156-18.676 1.88l-.01.008v-.008c-.405.307-.803.633-1.186.976a18.41 18.41 0 0 0-1.187-.976l.001.008-.01-.008c-5.37-4.036-12.521-4.76-18.678-1.88C6.14 3.842 2.75 7.55 1.078 12.185c-1.617 4.498-1.41 9.34.586 13.632 4.382 9.424 16.964 16.768 24.075 20.306a65.444 65.444 0 0 0 3.253 1.53l.018.008c.076.037.71.338 1.485.339h.01a3.656 3.656 0 0 0 1.485-.34l.018-.007a65.06 65.06 0 0 0 3.253-1.53c7.11-3.538 19.693-10.882 24.075-20.306 1.996-4.293 2.203-9.134.586-13.632zM53.13 22.892c-3.624 7.792-15.823 14.51-20.901 17.037-.602.3-1.132.556-1.577.765l-.007.004v-.004l-.143.067c-.047-.02-.094-.044-.143-.067v.004l-.008-.004c-.445-.209-.975-.466-1.577-.765-5.08-2.526-17.279-9.245-20.902-17.037-1.214-2.615-1.338-5.572-.347-8.323 1.042-2.89 3.165-5.207 5.982-6.524.54-.253 1.094-.461 1.655-.628a11.887 11.887 0 0 1 3.594-.553c5.46 0 9.955 3.812 11.248 8.787a.51.51 0 0 0 .492.383h.01a.51.51 0 0 0 .493-.383c1.293-4.976 5.787-8.787 11.248-8.787 1.254 0 2.461.194 3.594.553a11.98 11.98 0 0 1 1.655.628c2.816 1.317 4.94 3.635 5.982 6.524.99 2.752.867 5.708-.347 8.323z" />
  </CreateIconComponent>
);

export default BrandHeartIcon;
